<div class="food" [style]="style" [ngClass]="foodClass"></div>
